export default "__VITE_ASSET__a0787214__"